import { useQuery } from '@tanstack/react-query';
import { getAppConfig } from '../../../config';
import { loadCredentials } from '../../../apiClient';

type ConversationListItem = {
  id: string;
  title: string;
  createdAt: string;
  updatedAt: string;
};

export const GET_CONVERSATIONS_QUERY_KEY = (organizationId: string) => [
  'ai-assistant',
  organizationId,
  'conversations',
];

export function useGetConversations(organizationId: string | undefined) {
  return useQuery<ConversationListItem[]>({
    queryKey: GET_CONVERSATIONS_QUERY_KEY(organizationId ?? ''),
    queryFn: async () => {
      const { idToken } = loadCredentials();
      const response = await fetch(
        `${getAppConfig().apiUrl}/ai-assistant/conversations`,
        {
          headers: {
            authorization: idToken,
            'x-organization-id': organizationId,
          },
        },
      );

      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new Error(body?.message || `Request failed (${response.status})`);
      }

      return response.json();
    },
    enabled: !!organizationId,
    staleTime: 30_000,
  });
}
